export const isEmpty = (value: unknown[] | null) =>
  value == null || value.length === 0;
